import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import UploadPage from './pages/UploadPage';
import EditOfferPage from './pages/EditOfferPage';
import PublicOfferView from './pages/PublicOfferView';
import ImportPage from './pages/ImportPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/edit/:offerId" element={<EditOfferPage />} />
          <Route path="/offer/:shareLink" element={<PublicOfferView />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
